import React, { createContext, useContext, useMemo } from 'react';

const BoardSectionContext = createContext(null);

/**
 * Hook to access board section information
 * Returns isFromCase, isFromLead, isGlobal, and caseDetails
 */
export const useBoardSection = () => {
  const context = useContext(BoardSectionContext);
  if (!context) {
    throw new Error('useBoardSection must be used within BoardSectionProvider');
  }
  return context;
};

/**
 * BoardSectionProvider - Provides section context for TaskBoard
 *
 * @param {Object} props
 * @param {boolean} props.isFromLead - Is board mounted in Lead section
 * @param {boolean} props.isFromCase - Is board mounted in Case section
 * @param {Object} props.caseDetails - Case/Lead details object
 * @param {React.ReactNode} props.children
 */
export const BoardSectionProvider = ({ isFromLead = false, isFromCase = false, caseDetails = null, children }) => {
  const value = useMemo(
    () => ({
      isFromCase,
      isFromLead,
      isGlobal: !isFromCase && !isFromLead, // Automatically computed
      caseDetails,
    }),
    [isFromCase, isFromLead, caseDetails]
  );

  return <BoardSectionContext.Provider value={value}>{children}</BoardSectionContext.Provider>;
};
